import styled from "styled-components";

export const ContainerHeaderGrid = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: center;
	padding-top: 10px;
	padding-right: 10px;
	padding-left: 10px;
	gap: 1rem;
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;
